import { render } from "./SendPrayerButton.vue?vue&type=template&id=7786e118&scoped=true"
import script from "./SendPrayerButton.vue?vue&type=script&lang=js"
export * from "./SendPrayerButton.vue?vue&type=script&lang=js"

import "./SendPrayerButton.vue?vue&type=style&index=0&id=7786e118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7786e118"]])

export default __exports__